import assign from 'lodash/assign';
import { Actions, ActionTypes } from '~/types/products';
import { ReduxState } from '~/types/redux';

const products = (state: ReduxState, action: Actions): ReduxState => {
  switch (action.type) {
    case ActionTypes.SET_PRODUCTS:
      return assign({}, state, {
        products: {
          ...state.products,
          available: action.available,
          offerLevelSweeteners: action.offerLevelSweeteners,
        },
      });
    case ActionTypes.SELECT_PRODUCT:
      return assign({}, state, {
        products: {
          ...state.products,
          selected: {
            ...action.selectedState,
          },
        },
      });
    case ActionTypes.CLEAR_SELECT_PRODUCT:
      return assign({}, state, {
        products: {
          ...state.products,
          selected: undefined,
        },
      });
    case ActionTypes.SET_OFFER_TYPE:
      return assign({}, state, {
        products: {
          ...state.products,
          offerType: action.offerType,
        },
      });

    case ActionTypes.SET_SELECTED_SWEETENER:
      return assign({}, state, {
        products: {
          ...state.products,
          planPageSelections: {
            ...(state?.products?.planPageSelections || {}),
            selectedSweetener: action.selectedSweetener,
          },
        },
      });
    case ActionTypes.SET_NETFLIX_BUNDLE:
      return assign({}, state, {
        products: {
          ...state.products,
          planPageSelections: {
            ...(state?.products?.planPageSelections || {}),
            selectedNetflix: action.selectedNetflix,
          },
        },
      });
    case ActionTypes.SET_VRC_MODAL_SHOWN:
      return assign({}, state, {
        products: {
          ...state.products,
          planPageSelections: {
            ...(state?.products?.planPageSelections || {}),
            vrcModalShown: action.vrcModalShown,
          },
        },
      });
    case ActionTypes.SET_PHONE_SELECTION:
      return assign({}, state, {
        products: {
          ...state.products,
          planPageSelections: {
            ...(state?.products?.planPageSelections || {}),
            phoneSelection: action.phoneSelection,
          },
        },
      });
    case ActionTypes.SET_FIRST_AVAILABLE:
      return assign({}, state, {
        products: {
          ...state.products,
          firstAvailable: action.firstAvailable,
        },
      });
    case ActionTypes.SET_NDI_BANNER:
      return assign({}, state, {
        products: {
          ...state.products,
          ndiBanner: action.ndiBanner,
        },
      });
    case ActionTypes.SET_LANDING_PAGE_PRODUCT:
      return assign({}, state, {
        products: {
          ...state.products,
          landingPageProduct: action.landingPageProduct,
        },
      });
    case ActionTypes.SET_LANDING_PAGE_BUNDLE:
      return {
        ...state,
        products: {
          ...state.products,
          landingPageBundle: action.landingPageBundle,
        },
      };
    case ActionTypes.SET_LANDING_PAGE_PRODUCT_AVAILABLE:
      return assign({}, state, {
        products: {
          ...state.products,
          landingPageProductAvailable: action.landingPageProductAvailable,
        },
      });
    case ActionTypes.SET_OFFER_OBJECTS:
      return assign({}, state, {
        products: {
          ...state.products,
          offerObjects: action.offerObjects,
        },
      });
    case ActionTypes.SET_VAS_SETTINGS:
      return assign({}, state, {
        products: {
          ...state.products,
          vasSettings: {
            hasVas: action.hasVas,
            hasVasVersion: action.hasVasVersion,
            hasVasSubmitTextButton: action.hasVasSubmitTextButton,
            vasAlias: action.vasAlias,
          },
        },
      });
    case ActionTypes.SET_SALES_JOURNEY:
      return assign({}, state, {
        products: {
          ...state.products,
          salesJourney: action.salesJourney,
        },
      });
    case ActionTypes.SET_IS_COPPER_2_FIBER:
      return assign({}, state, {
        products: {
          ...state.products,
          isCopper2Fiber: action.isCopper2Fiber,
        },
      });
    case ActionTypes.SET_BAU_RECOMMENDATIONS:
      return assign({}, state, {
        bauRecommendations: action.recommendations,
      });
    case ActionTypes.SET_DYNAMIC_RTB:
      return assign({}, state, {
        recommendedRTBs: action.recommendedRTBs,
      });
    default:
      return state;
  }
};

export default products;
